export const setLTIThemeStyle = () => async () => {
  const tenantName = localStorage.getItem("tenantSlugName");
  const normalizedTenantName = tenantName?.toLowerCase();
  if (
    tenantName !== undefined &&
    (normalizedTenantName === "search" ||
      normalizedTenantName === "qaaadsep26" ||
      normalizedTenantName === "ltimindtree" ||
      normalizedTenantName === "ltm")
  ) {
    document.getElementsByTagName(
      "body"
    )[0].style.cssText = `font-family: "ESKlarheitGrotesk", sans-serif; background-color: #f6f6f6;`;
  } else {
    document.getElementsByTagName("body")[0].style.fontFamily = "";
  }
};
